import React, { useEffect, useState } from 'react'
import Main from '../../cpn/Main'
import { Space, Table } from 'antd';
import { useShangpinjiaochengListQuery } from '../../store/dianshangtaizhangApi';
import GoodsCourseEdit from './GoodsCourseEdit';
function GoodsCourseQuery() {
    const [list, setList] = useState();    
    const {data, isSuccess} = useShangpinjiaochengListQuery({}, {refetchOnMountOrArgChange: true})
    useEffect(() => {
        if (isSuccess) {
            console.log(data);
            if(data.Status==='success'){                
                const newArr = data.Result.map(item => {
                    const {spjc_id:key,spjc_day,spjc_price,spjc_name,spjc_content,spjc_ctime} = item;                 
                    return item = {key,spjc_day,spjc_price,spjc_name,spjc_content,spjc_ctime}
                }) 
                const sortArr = newArr.sort( (a, b) => {      
                    let aTimeString = a.spjc_ctime;
                    let bTimeString = b.spjc_ctime;
                    let aTime = new Date(aTimeString).getTime();
                    let bTime = new Date(bTimeString).getTime();
                    return bTime - aTime;     
                    },)
                setList(sortArr)
            }else{
                setList('')
            }
        }
    }, [data, isSuccess])
    const columns = [
        {
            key: 'spjc_name',
            title: '表单名称',            
            dataIndex: 'spjc_name',
        },
    
        {
            key: 'spjc_ctime',
            title: '创建时间',            
            dataIndex: 'spjc_ctime',
        },     
        {
            key: 'key',
            title: '编号',            
            dataIndex: 'key',
        },    
        {
            key: 'action',
            title: '操作',
            render: (_, record) => {
                return <>
                    <Space>
                        <GoodsCourseEdit spjc_id={record.key} spjc_name={record.spjc_name} />
                    </Space>
                </>
            }
        },
    ]   
    return (
        <Main selectedKeys={['/GoodsCourseQuery']}>                     
            <Table 
                columns={columns} 
                dataSource={list} 
                pagination={{
                    showSizeChanger:true,
                    defaultPageSize:'50',
                    showTotal:(total) => `共${total}条`,
                }} 
            />
        </Main>
    )
}


export default GoodsCourseQuery